export default __webpack_public_path__ + "static/media/health.2f463404.jpg";